import { QueryClient } from '@tanstack/react-query';

import { logger } from '@/lib/logger';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error: unknown) => {
        const err = error instanceof Error ? error : new Error(String(error));
        logger.error('Mutation error', err);
      },
    },
  },
});
